import { forwardRef, type InputHTMLAttributes, type ReactNode, useEffect, useImperativeHandle, useRef } from "react";
import { cx } from "../cx";
import styles from "./Checkbox.module.css";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: ReactNode;
  indeterminate?: boolean;
  className?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, indeterminate = false, className, ...rest },
  ref,
) {
  const inner = useRef<HTMLInputElement>(null);
  useImperativeHandle(ref, () => inner.current as HTMLInputElement);
  useEffect(() => {
    if (inner.current) inner.current.indeterminate = indeterminate;
  }, [indeterminate]);
  return (
    <label className={cx(styles.root, rest.disabled && styles.disabled, className)}>
      <input ref={inner} type="checkbox" className={styles.input} {...rest} />
      <span className={styles.box} aria-hidden="true" />
      {label !== undefined && <span className={styles.label}>{label}</span>}
    </label>
  );
});
